import { render, staticRenderFns } from "./AgentGeneralPermissions.vue?vue&type=template&id=408cdd8e"
import script from "./AgentGeneralPermissions.vue?vue&type=script&lang=js"
export * from "./AgentGeneralPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports